import type { FaireProductEntity } from "../../entity_types/product";

export const p_wtsxf52tq6: FaireProductEntity = {
  token: "p_wtsxf52tq6",
  type: "product",
  name: "Murdle Jr.: Holiday Hijinks!",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/144aa74e5d03adad97b5b9fe68d53360c22333c8c2bbfee6db415fbc32b20f59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86045d69317fbf017b43195fd4d9b06a8944c0a677fdf9cea32db4b6b0c7cc43.jpeg",
    "https://cdn.faire.com/fastly/c1bed1415b09680b4016091ab618274977d99af27e2d1e0374ac52205a104b0e.jpeg",
    "https://cdn.faire.com/fastly/b4f10736d59314df2dc67c9933646597ceef44fd95af59cf5a5863d6b08dbbe9.jpeg",
    "https://cdn.faire.com/fastly/12fc9d2b2eeb20ed3c05edc3b035a0dd08e24bf6c9151fb094e67d583661c54f.jpeg",
    "https://cdn.faire.com/fastly/0485be0325049fa72bd822a35849ad919b0fcbe1fb3f6438109b1a3ec94d381d.jpeg",
    "https://cdn.faire.com/fastly/9a47c0dec057f9a7b6df2ba292c43f3d0ee48b9cba09884456493c0bfe0b1b6b.jpeg"
  ],
  priceDollars: 4.5,
  description: "Discover the internationally bestselling Murdle Jr. phenomenon! Perfect for kids and families on the go, this thrilling activity book is jam-packed with hours of immersive puzzles including mazes, word searches, codes, and classic Murdle mysteries. Junior detective Buster McPaws is excited to curl up next to the fire at the ski resort—but once again he gets pulled into an avalanche of troubling mysteries! It’s up to YOU to crack the case so that Buster can finally relax and have the purrfect wintry day! Enjoy hours of kid-tested fun with a variety of puzzles, word searches, mazes, and codes that unlock the mystery. Discover Murdle Jr. Mini: An engaging, screen-free activity! Increase your logic and reasoning skills with these interactive activities! Perfect for car rides, travel, and sleuthing on the go! Build confidence with bite-sized brainteasers! Fun for the whole family! SOLVE THE PUZZLES: Curious Crimes for Curious Minds. Ready, Set, Solve! Wild Goose Case. ENJOY THE MINIS: Summer Fun! Holiday Hijinks! READ THE MYSTERIES: Sleuths on the Loose, Codes, Cover-Ups, and Cookies.",
  tags: [],
  msrpDollars: 8.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:59.904Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
